export default function getFileNameFromUrl(url: string) {
  return url.split('/').pop();
}
